import AD from 'images/icons/flag/40x40/AD.png';
import AE from 'images/icons/flag/40x40/AE.png';
import AF from 'images/icons/flag/40x40/AF.png';
import AG from 'images/icons/flag/40x40/AG.png';
import AI from 'images/icons/flag/40x40/AI.png';
import AL from 'images/icons/flag/40x40/AL.png';
import AM from 'images/icons/flag/40x40/AM.png';
import AN from 'images/icons/flag/40x40/AN.png';
import AO from 'images/icons/flag/40x40/AO.png';
import AQ from 'images/icons/flag/40x40/AQ.png';
import AR from 'images/icons/flag/40x40/AR.png';
import AS from 'images/icons/flag/40x40/AS.png';
import AT from 'images/icons/flag/40x40/AT.png';
import AU from 'images/icons/flag/40x40/AU.png';
import AW from 'images/icons/flag/40x40/AW.png';
import AZ from 'images/icons/flag/40x40/AZ.png';
import BA from 'images/icons/flag/40x40/BA.png';
import BB from 'images/icons/flag/40x40/BB.png';
import BD from 'images/icons/flag/40x40/BD.png';
import BE from 'images/icons/flag/40x40/BE.png';
import BF from 'images/icons/flag/40x40/BF.png';
import BG from 'images/icons/flag/40x40/BG.png';
import BH from 'images/icons/flag/40x40/BH.png';
import BI from 'images/icons/flag/40x40/BI.png';
import BJ from 'images/icons/flag/40x40/BJ.png';
import BL from 'images/icons/flag/40x40/BL.png';
import BM from 'images/icons/flag/40x40/BM.png';
import BN from 'images/icons/flag/40x40/BN.png';
import BO from 'images/icons/flag/40x40/BO.png';
import BQ from 'images/icons/flag/40x40/BQ.png';
import BR from 'images/icons/flag/40x40/BR.png';
import BS from 'images/icons/flag/40x40/BS.png';
import BT from 'images/icons/flag/40x40/BT.png';
import BW from 'images/icons/flag/40x40/BW.png';
import BY from 'images/icons/flag/40x40/BY.png';
import BZ from 'images/icons/flag/40x40/BZ.png';
import CA from 'images/icons/flag/40x40/CA.png';
import CC from 'images/icons/flag/40x40/CC.png';
import CD from 'images/icons/flag/40x40/CD.png';
import CF from 'images/icons/flag/40x40/CF.png';
import CG from 'images/icons/flag/40x40/CG.png';
import CH from 'images/icons/flag/40x40/CH.png';
import CI from 'images/icons/flag/40x40/CI.png';
import CK from 'images/icons/flag/40x40/CK.png';
import CL from 'images/icons/flag/40x40/CL.png';
import CM from 'images/icons/flag/40x40/CM.png';
import CN from 'images/icons/flag/40x40/CN.png';
import CO from 'images/icons/flag/40x40/CO.png';
import CR from 'images/icons/flag/40x40/CR.png';
import CU from 'images/icons/flag/40x40/CU.png';
import CV from 'images/icons/flag/40x40/CV.png';
import CW from 'images/icons/flag/40x40/CW.png';
import CX from 'images/icons/flag/40x40/CX.png';
import CY from 'images/icons/flag/40x40/CY.png';
import CZ from 'images/icons/flag/40x40/CZ.png';
import DE from 'images/icons/flag/40x40/DE.png';
import DJ from 'images/icons/flag/40x40/DJ.png';
import DK from 'images/icons/flag/40x40/DK.png';
import DO from 'images/icons/flag/40x40/DO.png';
import DZ from 'images/icons/flag/40x40/DZ.png';
import EC from 'images/icons/flag/40x40/EC.png';
import EE from 'images/icons/flag/40x40/EE.png';
import EG from 'images/icons/flag/40x40/EG.png';
import ER from 'images/icons/flag/40x40/ER.png';
import ES from 'images/icons/flag/40x40/ES.png';
import ET from 'images/icons/flag/40x40/ET.png';
import EU from 'images/icons/flag/40x40/EU.png';
import FI from 'images/icons/flag/40x40/FI.png';
import FJ from 'images/icons/flag/40x40/FJ.png';
import FK from 'images/icons/flag/40x40/FK.png';
import FM from 'images/icons/flag/40x40/FM.png';
import FO from 'images/icons/flag/40x40/FO.png';
import FR from 'images/icons/flag/40x40/FR.png';
import GA from 'images/icons/flag/40x40/GA.png';
import GB from 'images/icons/flag/40x40/GB.png';
import GD from 'images/icons/flag/40x40/GD.png';
import GE from 'images/icons/flag/40x40/GE.png';
import GG from 'images/icons/flag/40x40/GG.png';
import GH from 'images/icons/flag/40x40/GH.png';
import GI from 'images/icons/flag/40x40/GI.png';
import GL from 'images/icons/flag/40x40/GL.png';
import GM from 'images/icons/flag/40x40/GM.png';
import GN from 'images/icons/flag/40x40/GN.png';
import GP from 'images/icons/flag/40x40/GP.png';
import GQ from 'images/icons/flag/40x40/GQ.png';
import GR from 'images/icons/flag/40x40/GR.png';
import GS from 'images/icons/flag/40x40/GS.png';
import GT from 'images/icons/flag/40x40/GT.png';
import GU from 'images/icons/flag/40x40/GU.png';
import GW from 'images/icons/flag/40x40/GW.png';
import GY from 'images/icons/flag/40x40/GY.png';
import HK from 'images/icons/flag/40x40/HK.png';
import HN from 'images/icons/flag/40x40/HN.png';
import HR from 'images/icons/flag/40x40/HR.png';
import HT from 'images/icons/flag/40x40/HT.png';
import HU from 'images/icons/flag/40x40/HU.png';
import ID from 'images/icons/flag/40x40/ID.png';
import IE from 'images/icons/flag/40x40/IE.png';
import IL from 'images/icons/flag/40x40/IL.png';
import IM from 'images/icons/flag/40x40/IM.png';
import IN from 'images/icons/flag/40x40/IN.png';
import IO from 'images/icons/flag/40x40/IO.png';
import IQ from 'images/icons/flag/40x40/IQ.png';
import IR from 'images/icons/flag/40x40/IR.png';
import IS from 'images/icons/flag/40x40/IS.png';
import IT from 'images/icons/flag/40x40/IT.png';
import JE from 'images/icons/flag/40x40/JE.png';
import JM from 'images/icons/flag/40x40/JM.png';
import JO from 'images/icons/flag/40x40/JO.png';
import JP from 'images/icons/flag/40x40/JP.png';
import KE from 'images/icons/flag/40x40/KE.png';
import KG from 'images/icons/flag/40x40/KG.png';
import KH from 'images/icons/flag/40x40/KH.png';
import KI from 'images/icons/flag/40x40/KI.png';
import KM from 'images/icons/flag/40x40/KM.png';
import KN from 'images/icons/flag/40x40/KN.png';
import KP from 'images/icons/flag/40x40/KP.png';
import KR from 'images/icons/flag/40x40/KR.png';
import KW from 'images/icons/flag/40x40/KW.png';
import KY from 'images/icons/flag/40x40/KY.png';
import KZ from 'images/icons/flag/40x40/KZ.png';
import LA from 'images/icons/flag/40x40/LA.png';
import LB from 'images/icons/flag/40x40/LB.png';
import LC from 'images/icons/flag/40x40/LC.png';
import LI from 'images/icons/flag/40x40/LI.png';
import LK from 'images/icons/flag/40x40/LK.png';
import LR from 'images/icons/flag/40x40/LR.png';
import LS from 'images/icons/flag/40x40/LS.png';
import LT from 'images/icons/flag/40x40/LT.png';
import LU from 'images/icons/flag/40x40/LU.png';
import LV from 'images/icons/flag/40x40/LV.png';
import LY from 'images/icons/flag/40x40/LY.png';
import MA from 'images/icons/flag/40x40/MA.png';
import MC from 'images/icons/flag/40x40/MC.png';
import MD from 'images/icons/flag/40x40/MD.png';
import ME from 'images/icons/flag/40x40/ME.png';
import MF from 'images/icons/flag/40x40/MF.png';
import MG from 'images/icons/flag/40x40/MG.png';
import MH from 'images/icons/flag/40x40/MH.png';
import MK from 'images/icons/flag/40x40/MK.png';
import ML from 'images/icons/flag/40x40/ML.png';
import MM from 'images/icons/flag/40x40/MM.png';
import MN from 'images/icons/flag/40x40/MN.png';
import MO from 'images/icons/flag/40x40/MO.png';
import MP from 'images/icons/flag/40x40/MP.png';
import MQ from 'images/icons/flag/40x40/MQ.png';
import MR from 'images/icons/flag/40x40/MR.png';
import MS from 'images/icons/flag/40x40/MS.png';
import MT from 'images/icons/flag/40x40/MT.png';
import MU from 'images/icons/flag/40x40/MU.png';
import MV from 'images/icons/flag/40x40/MV.png';
import MW from 'images/icons/flag/40x40/MW.png';
import MX from 'images/icons/flag/40x40/MX.png';
import MY from 'images/icons/flag/40x40/MY.png';
import MZ from 'images/icons/flag/40x40/MZ.png';
import NA from 'images/icons/flag/40x40/NA.png';
import NC from 'images/icons/flag/40x40/NC.png';
import NE from 'images/icons/flag/40x40/NE.png';
import NF from 'images/icons/flag/40x40/NF.png';
import NG from 'images/icons/flag/40x40/NG.png';
import NI from 'images/icons/flag/40x40/NI.png';
import NL from 'images/icons/flag/40x40/NL.png';
import NO from 'images/icons/flag/40x40/NO.png';
import NP from 'images/icons/flag/40x40/NP.png';
import NR from 'images/icons/flag/40x40/NR.png';
import NU from 'images/icons/flag/40x40/NU.png';
import NZ from 'images/icons/flag/40x40/NZ.png';
import OM from 'images/icons/flag/40x40/OM.png';
import PA from 'images/icons/flag/40x40/PA.png';
import PE from 'images/icons/flag/40x40/PE.png';
import PF from 'images/icons/flag/40x40/PF.png';
import PG from 'images/icons/flag/40x40/PG.png';
import PH from 'images/icons/flag/40x40/PH.png';
import PK from 'images/icons/flag/40x40/PK.png';
import PL from 'images/icons/flag/40x40/PL.png';
import PM from 'images/icons/flag/40x40/PM.png';
import PN from 'images/icons/flag/40x40/PN.png';
import PR from 'images/icons/flag/40x40/PR.png';
import PS from 'images/icons/flag/40x40/PS.png';
import PT from 'images/icons/flag/40x40/PT.png';
import PW from 'images/icons/flag/40x40/PW.png';
import PY from 'images/icons/flag/40x40/PY.png';
import QA from 'images/icons/flag/40x40/QA.png';
import RO from 'images/icons/flag/40x40/RO.png';
import RS from 'images/icons/flag/40x40/RS.png';
import RU from 'images/icons/flag/40x40/RU.png';
import RW from 'images/icons/flag/40x40/RW.png';
import SA from 'images/icons/flag/40x40/SA.png';
import SB from 'images/icons/flag/40x40/SB.png';
import SC from 'images/icons/flag/40x40/SC.png';
import SD from 'images/icons/flag/40x40/SD.png';
import SE from 'images/icons/flag/40x40/SE.png';
import SG from 'images/icons/flag/40x40/SG.png';
import SH from 'images/icons/flag/40x40/SH.png';
import SI from 'images/icons/flag/40x40/SI.png';
import SJ from 'images/icons/flag/40x40/SJ.png';
import SK from 'images/icons/flag/40x40/SK.png';
import SL from 'images/icons/flag/40x40/SL.png';
import SM from 'images/icons/flag/40x40/SM.png';
import SN from 'images/icons/flag/40x40/SN.png';
import SO from 'images/icons/flag/40x40/SO.png';
import SR from 'images/icons/flag/40x40/SR.png';
import SS from 'images/icons/flag/40x40/SS.png';
import ST from 'images/icons/flag/40x40/ST.png';
import SV from 'images/icons/flag/40x40/SV.png';
import SY from 'images/icons/flag/40x40/SY.png';
import SZ from 'images/icons/flag/40x40/SZ.png';
import TC from 'images/icons/flag/40x40/TC.png';
import TD from 'images/icons/flag/40x40/TD.png';
import TG from 'images/icons/flag/40x40/TG.png';
import TH from 'images/icons/flag/40x40/TH.png';
import TJ from 'images/icons/flag/40x40/TJ.png';
import TK from 'images/icons/flag/40x40/TK.png';
import TL from 'images/icons/flag/40x40/TL.png';
import TM from 'images/icons/flag/40x40/TM.png';
import TN from 'images/icons/flag/40x40/TN.png';
import TO from 'images/icons/flag/40x40/TO.png';
import TP from 'images/icons/flag/40x40/TP.png';
import TR from 'images/icons/flag/40x40/TR.png';
import TT from 'images/icons/flag/40x40/TT.png';
import TV from 'images/icons/flag/40x40/TV.png';
import TW from 'images/icons/flag/40x40/TW.png';
import TZ from 'images/icons/flag/40x40/TZ.png';
import UA from 'images/icons/flag/40x40/UA.png';
import UG from 'images/icons/flag/40x40/UG.png';
import US from 'images/icons/flag/40x40/US.png';
import UY from 'images/icons/flag/40x40/UY.png';
import UZ from 'images/icons/flag/40x40/UZ.png';
import VA from 'images/icons/flag/40x40/VA.png';
import VC from 'images/icons/flag/40x40/VC.png';
import VE from 'images/icons/flag/40x40/VE.png';
import VG from 'images/icons/flag/40x40/VG.png';
import VI from 'images/icons/flag/40x40/VI.png';
import VN from 'images/icons/flag/40x40/VN.png';
import VU from 'images/icons/flag/40x40/VU.png';
import WF from 'images/icons/flag/40x40/WF.png';
import WS from 'images/icons/flag/40x40/WS.png';
import XK from 'images/icons/flag/40x40/XK.png';
import YE from 'images/icons/flag/40x40/YE.png';
import YT from 'images/icons/flag/40x40/YT.png';
import ZA from 'images/icons/flag/40x40/ZA.png';
import ZM from 'images/icons/flag/40x40/ZM.png';
import ZW from 'images/icons/flag/40x40/ZW.png';

export default {
	AD,
	AE,
	AF,
	AG,
	AI,
	AL,
	AM,
	AN,
	AO,
	AQ,
	AR,
	AS,
	AT,
	AU,
	AW,
	AZ,
	BA,
	BB,
	BD,
	BE,
	BF,
	BG,
	BH,
	BI,
	BJ,
	BL,
	BM,
	BN,
	BO,
	BQ,
	BR,
	BS,
	BT,
	BW,
	BY,
	BZ,
	CA,
	CC,
	CD,
	CF,
	CG,
	CH,
	CI,
	CK,
	CL,
	CM,
	CN,
	CO,
	CR,
	CU,
	CV,
	CW,
	CX,
	CY,
	CZ,
	DE,
	DJ,
	DK,
	DO,
	DZ,
	EC,
	EE,
	EG,
	ER,
	ES,
	ET,
	EU,
	FI,
	FJ,
	FK,
	FM,
	FO,
	FR,
	GA,
	GB,
	UK: GB,
	GD,
	GE,
	GG,
	GH,
	GI,
	GL,
	GM,
	GN,
	GP,
	GQ,
	GR,
	GS,
	GT,
	GU,
	GW,
	GY,
	HK,
	HN,
	HR,
	HT,
	HU,
	ID,
	IE,
	IL,
	IM,
	IN,
	IO,
	IQ,
	IR,
	IS,
	IT,
	JE,
	JM,
	JO,
	JP,
	KE,
	KG,
	KH,
	KI,
	KM,
	KN,
	KP,
	KR,
	KW,
	KY,
	KZ,
	LA,
	LB,
	LC,
	LI,
	LK,
	LR,
	LS,
	LT,
	LU,
	LV,
	LY,
	MA,
	MC,
	MD,
	ME,
	MF,
	MG,
	MH,
	MK,
	ML,
	MM,
	MN,
	MO,
	MP,
	MQ,
	MR,
	MS,
	MT,
	MU,
	MV,
	MW,
	MX,
	MY,
	MZ,
	NA,
	NC,
	NE,
	NF,
	NG,
	NI,
	NL,
	NO,
	NP,
	NR,
	NU,
	NZ,
	OM,
	PA,
	PE,
	PF,
	PG,
	PH,
	PK,
	PL,
	PM,
	PN,
	PR,
	PS,
	PT,
	PW,
	PY,
	QA,
	RO,
	RS,
	RU,
	RW,
	SA,
	SB,
	SC,
	SD,
	SE,
	SG,
	SH,
	SI,
	SJ,
	SK,
	SL,
	SM,
	SN,
	SO,
	SR,
	SS,
	ST,
	SV,
	SY,
	SZ,
	TC,
	TD,
	TG,
	TH,
	TJ,
	TK,
	TL,
	TM,
	TN,
	TO,
	TP,
	TR,
	TT,
	TV,
	TW,
	TZ,
	UA,
	UG,
	US,
	UY,
	UZ,
	VA,
	VC,
	VE,
	VG,
	VI,
	VN,
	VU,
	WF,
	WS,
	XK,
	YE,
	YT,
	ZA,
	ZM,
	ZW,
};
